import React from 'react';
import { GenericDetailPage } from '../../components/generic';
import { useOffer, Offer } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<Offer>
      useData={useOffer}
      config={{
        ...moduleConfig,
        getDetailSections: (item, formatDate, formatCurrency, mutate) =>
          getDetailSections(
            item,
            (d?: string | null) => (formatDate ?? moduleConfig.utils.formatDate)(d ?? undefined),
            formatCurrency ?? moduleConfig.utils.formatCurrency,
            mutate
          ),
        getStatusBadges,
      }}
    />
  );
};

export default Detail;
